import IconVisa from '@scramble/design-system/icons/payment/visa.svg';
import IconMasterCard from '@scramble/design-system/icons/payment/mastercard.svg';
import IconSepa from '@scramble/design-system/icons/payment/sepa.svg';
import IconGooglePay from '@scramble/design-system/icons/payment/google-pay.svg';
import IconApplePay from '@scramble/design-system/icons/payment/apple-pay.svg';
import s from './index.module.scss';

export const PaymentMethodIcons = () => {
  return (
    <div className={s.wrapper}>
      <img src={IconVisa} alt="visa" width={53} height={32} />
      <img src={IconMasterCard} alt="mastercard" width={53} height={32} />
      <img src={IconSepa} alt="sepa" width={53} height={32} />
      <img src={IconGooglePay} alt="google-pay" width={53} height={32} />
      <img src={IconApplePay} alt="apple-pay" width={53} height={32} />
    </div>
  );
};